/**
 * API functions for the Centralised PT Plan feature.
 * All endpoints sit under /centralized-pt-plan on the backend.
 */

import { BASE_URL } from "../../data/BaseUrl";

const BASE = "centralized-pt-plan";

const qs = (filters = {}) => {
  const params = Object.entries(filters)
    .filter(([, v]) => v !== "" && v !== undefined && v !== null)
    .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
    .join("&");
  return params ? `?${params}` : "";
};

const jsonHeaders = (token) => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${token}`,
});

const authHeaders = (token) => ({
  Authorization: `Bearer ${token}`,
});

// List drafts
export const fetchPtPlanDrafts = async (filters, token) => {
  try {
    const res = await fetch(`${BASE_URL}/${BASE}/draft${qs(filters)}`, {
      method: "GET",
      headers: authHeaders(token),
    });
    return await res.json();
  } catch (err) {
    console.error("fetchPtPlanDrafts error:", err);
    return { status: false, message: err.message, data: [] };
  }
};

// Create a draft. `formData` must be FormData (for optional image upload).
export const createPtPlanDraft = async (formData, token) => {
  try {
    const res = await fetch(`${BASE_URL}/${BASE}/draft`, {
      method: "POST",
      headers: authHeaders(token),
      body: formData,
    });
    return await res.json();
  } catch (err) {
    console.error("createPtPlanDraft error:", err);
    return { status: false, message: err.message };
  }
};

// Update a draft. `formData` must be FormData.
export const updatePtPlanDraft = async (formData, token) => {
  try {
    const res = await fetch(`${BASE_URL}/${BASE}/draft`, {
      method: "PUT",
      headers: authHeaders(token),
      body: formData,
    });
    return await res.json();
  } catch (err) {
    console.error("updatePtPlanDraft error:", err);
    return { status: false, message: err.message };
  }
};

// Soft delete a draft.
export const deletePtPlanDraft = async (uid, token) => {
  try {
    const res = await fetch(`${BASE_URL}/${BASE}/draft?uid=${encodeURIComponent(uid)}`, {
      method: "DELETE",
      headers: authHeaders(token),
    });
    return await res.json();
  } catch (err) {
    console.error("deletePtPlanDraft error:", err);
    return { status: false, message: err.message };
  }
};

// Bulk map a draft to many gyms.
export const mapPtPlanToGyms = async (payload, token) => {
  try {
    const res = await fetch(`${BASE_URL}/${BASE}/map`, {
      method: "POST",
      headers: jsonHeaders(token),
      body: JSON.stringify(payload),
    });
    return await res.json();
  } catch (err) {
    console.error("mapPtPlanToGyms error:", err);
    return { status: false, message: err.message };
  }
};

// List gyms a draft is mapped to.
export const fetchPtPlanMappedGyms = async (draft_uid, token) => {
  try {
    const res = await fetch(
      `${BASE_URL}/${BASE}/mapped-gyms?draft_uid=${encodeURIComponent(draft_uid)}`,
      { method: "GET", headers: authHeaders(token) }
    );
    return await res.json();
  } catch (err) {
    console.error("fetchPtPlanMappedGyms error:", err);
    return { status: false, message: err.message, data: [] };
  }
};

// Unmap one gym from a draft.
export const unmapPtPlanFromGym = async (addon_uid, token) => {
  try {
    const res = await fetch(
      `${BASE_URL}/${BASE}/unmap?addon_uid=${encodeURIComponent(addon_uid)}`,
      { method: "DELETE", headers: authHeaders(token) }
    );
    return await res.json();
  } catch (err) {
    console.error("unmapPtPlanFromGym error:", err);
    return { status: false, message: err.message };
  }
};
